import makeStyles from '@mui/styles/makeStyles';
import { getBrandCustom } from "../../utils/getCustomColor";

const styles = makeStyles(() => ({
  title: {
    fontFamily: "Manrope",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "24px",
    textAlign: "left",
  },
  icon: {
    margin: "0px 0 0 7px",
    cursor: "pointer",
  },
  flex: {
    display: "flex",
  },
  list: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    justifyContent: "flex-start",
    padding: "8px 16px",

    "& span": {
      fontFamily: "Manrope",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "12px",
      lineHeight: "14.4px",
    },
  },
  hideAll: {
    cursor: "pointer",
    color: getBrandCustom("primaryColor", "#0055A4"),
  },
  header: {
    display: "flex",
    flexDirection: "row",
    gap: "4px",
    justifyContent: "space-between",
    padding: "8px, 16px, 8px, 16px",
    marginBottom: "10px",
  },
  columnOption: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "8px 4px",

    "& span": {
      fontWeight: 500,
      fontSize: "14px",
    },
  },
  listItem: {
    fontFamily: "Manrope",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "14.4px",
    color: "#667085",
  },
}));

export default styles;
